import React from 'react'
import { Spinner } from 'react-bootstrap'

export default function FCMLoading() {
  return (
    <>
      <div className="d-flex w-100 h-100 justify-content-center align-items-center">
        <Spinner
          animation="border"
          variant="info"
          className=""
          size="xxl"
          style={{
            zIndex: 10000,
            marginLeft: 'auto',
            marginRight: 'auto',
            width: 100,
            height: 100,
          }}
        />
      </div>
    </>
  )
}
